
import { defineComponent } from 'vue'
import Footer from '@/components/footer/Footer.vue'
import Header from '@/components/header/Header.vue'

export default defineComponent({
  name: 'App',
  components: {
    Footer,
    Header
  },
  computed: {
    showFooter(): boolean {
      return this.$route.meta.showFooter
    }
  },
  methods: {
    onDrawerToggled(open: boolean): void {
      document.body.className = open ? 'drawer-open' : ''
    }
  }
})
